import { FunctionComponent } from "react";
import ListItem from "../ListItem/ListItem";
import Button from "../Button/Button";
import { Heading } from "../Text/Heading";
import { JsonValue } from "@prisma/client";

export interface OptInSummaryProps {
  id: string;
  questionId: string;
  heading: string;
  icon: string;
  iconLabel: string;
  answers: any;
  score: { [key: string]: any };
  list: [
    {
      id: string;
      icon: string;
      label: string;
      ref: string;
    }
  ];
  links: JsonValue;
}

const OptInSummary: FunctionComponent<OptInSummaryProps> = ({
  id,
  questionId,
  icon,
  iconLabel,
  heading,
  list,
  answers,
  children,
  score,
}) => {
  const listItems = list.map((listItem, index) => {
    let refLabel;
    if (listItem.ref) {
      const answer = answers[listItem.ref];
      if (answer?.data) {
        let stringArray = [];
        if (answer.type === "input") {
          stringArray = Object.values(answer.data).map(
            (el: any) => el?.value || "––"
          );
        } else {
          stringArray = Object.values(answer.data).map(
            (el: any) => el?.label || "––"
          );
        }
        refLabel = stringArray.join(", ");
      }
    }
    return (
      <ListItem
        icon={listItem.icon}
        key={`${index}-${listItem.id}`}
        last={index === list.length - 1}
      >
        {listItem.label}
        {refLabel}
      </ListItem>
    );
  });
  let displayedScore: number = 0;
  for (const id in score) {
    displayedScore += score[id];
  }
  return (
    <div
      className={
        "flex flex-col p-8 lg:p-10 border rounded-single-choice lg:max-w-md  w-full text-left border-gray-300"
      }
    >
      <div className="flex mb-2 items-center">
        {icon ? <img src={icon} className="mr-3" /> : null}
        <p>{iconLabel}</p>
      </div>
      <Heading level={3} className="mb-8">
        {heading}
      </Heading>
      <ul className="mb-8">{listItems}</ul>
      <div className="flex items-baseline h-full">
        <Heading level={2} className="text-3xl text-primary font-bold">
          {displayedScore.toFixed(2)}€
          <span className="text-gray-500 text-xl font-normal"> /Monat</span>
        </Heading>
      </div>
    </div>
  );
};

export default OptInSummary;
